import { Map } from "ol";
import { globalMap } from "../main";
import { MultiLineString, MultiPoint, MultiPolygon, Point } from "ol/geom";
import { SERVER } from "./defaults";
import Text from "ol/style/Text";
import Fill from "ol/style/Fill";
import Stroke from "ol/style/Stroke";
import { layers } from "./layers";
import { layersSourceFilenames } from "./sources";

const today = () => {
  var today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth() + 1; //January is 0!
  var yyyy = today.getFullYear();

  if (dd < 10) {
    dd = "0" + dd;
  }

  if (mm < 10) {
    mm = "0" + mm;
  }

  //today = mm + '/' + dd + '/' + yyyy;
  today = yyyy + "" + mm + "" + dd;
  return today;
};

/**
 *
 * @param {Map} map
 * @returns
 */
const fgbBoundingBox = (map = globalMap) => {
  if (!map) {
    return {
      minX: 0,
      minY: 0,
      maxX: 0,
      maxY: 0,
    };
  }
  const box = map.getView().calculateExtent(map.getSize());
  return {
    minX: box[0],
    minY: box[1],
    maxX: box[2],
    maxY: box[3],
  };
};

const debounce = (callback, wait = 300) => {
  let timeoutId = null;
  return (...args) => {
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => {
      callback(...args);
    }, wait);
  };
};

const getScale = (resolution) => {
  // let scale = 0.01;
  if (resolution < 1000) return 0.015;
  if (resolution < 300) return 0.02;
  if (resolution < 200) return 0.025;
  if (resolution < 100) return 0.03;

  return 0.01;
};

const getCount = async (filename) => {
  const response = await fetch(`${SERVER}/api/getCounts?tab=${filename}`);
  const body = await response.json();
  return body || 0;
};

/**
 * Builds a source URL by concatenating the server URL, the filename, and a query parameter for the current date.
 *
 * @param {string} filename - The name of the file to be included in the source URL with extension! (.fgb etc)
 * @return {string} The fully constructed source URL.
 */
const buildSourceUrl = (filename) => {
  return SERVER + `/js/${filename}` + "?v=" + today();
};

const convertGeometry = (geometry) => {
  if (geometry.type == "MultiPoint") {
    return new MultiPoint(geometry.coordinates);
  } else if (geometry.type == "Point") {
    return new Point(geometry.coordinates);
  } else if (geometry.type == "MultiPolygon") {
    return new MultiPolygon(geometry.coordinates);
  } else if (geometry.type == "MultiLineString") {
    return new MultiLineString(geometry.coordinates);
  }
  return geometry;
};

const createTextStyle = (feature, resolution, dom, field) => {
  const align = dom.align;
  const baseline = dom.baseline;
  const size = dom.size;
  const height = dom.height;
  const offsetX = parseInt(dom.offsetX, 10);
  const offsetY = parseInt(dom.offsetY, 10);
  const weight = dom.weight;
  const placement = dom.placement ? dom.placement : undefined;
  const maxAngle = dom.maxangle ? parseFloat(dom.maxangle) : undefined;
  const overflow = dom.overflow ? dom.overflow == "true" : undefined;
  const rotation = parseFloat(dom.rotation);
  if (dom.font == "'Open Sans'" && !openSansAdded) {
    const openSans = document.createElement("link");
    openSans.href = "https://fonts.googleapis.com/css?family=Open+Sans";
    openSans.rel = "stylesheet";
    document.getElementsByTagName("head")[0].appendChild(openSans);
    openSansAdded = true;
  }
  const font = weight + " " + size + "/" + height + " " + dom.font;
  const fillColor = dom.color;
  const outlineColor = dom.outline;
  const outlineWidth = parseInt(dom.outlineWidth, 10);

  return new Text({
    textAlign: align == "" ? undefined : align,
    textBaseline: baseline,
    font: font,
    text: getText(feature, resolution, dom, field),
    fill: new Fill({ color: fillColor }),
    stroke: new Stroke({ color: outlineColor, width: outlineWidth }),
    offsetX: offsetX,
    offsetY: offsetY,
    placement: placement,
    maxAngle: maxAngle,
    overflow: overflow,
    rotation: rotation,
  });
};

const getText = (feature, resolution, dom, field) => {
  // const type = dom.text;
  // const maxResolution = dom.maxreso;

  const text = feature.get("OGN"); //+" "+feature.get('sigla_pro')
  return text;
};

const checkGeometry = (url) => {
  if (url.includes(layersSourceFilenames.GNA.punti)) {
    return "punti";
  } else if (url.includes(layersSourceFilenames.GNA.linee)) {
    return "linee";
  } else if (url.includes(layersSourceFilenames.GNA.poligoni2)) {
    return "poligini";
  } else if (url.includes(layersSourceFilenames.GNA.progetti)) {
    return "progetti";
  } else if (url.includes(layersSourceFilenames.GNA.ricostruitiLinee)) {
    return "ricostruiti linee";
  } else {
    return "ricostruiti poligoni";
  }
};

const emptyIfNull = (key, value) => {
  if (!value) return ``;
  else return `<p>${key}: <span>${value}</span></p>`;
};

const emptyIfNull2 = (src, name) => {
  if (!src || !name) return ``;
  else
    return `<div class="gna-point"><img class="gna-pointImg" src="${src}"><span>${name}</span></div>`;
};

const emptyIfNull3 = (src, name) => {
  if (!src || !name) return ``;
  else
    return `<div class="gna-point-modal"><img class="gna-pointImg" src="${src}"><span>${name}</span></div>`;
};

const emptyIfNull4 = (key, value) => {
  if (!value) return ``;
  else return `<p><span>${key}:</span> ${value}</p>`;
};

export {
  today,
  debounce,
  fgbBoundingBox,
  buildSourceUrl,
  convertGeometry,
  getScale,
  getText,
  createTextStyle,
  checkGeometry,
  emptyIfNull,
  emptyIfNull2,
  emptyIfNull3,
  emptyIfNull4,
  getCount,
};
